import { ReactComponent as IconBanner} from "./IconBanner.svg";
export default IconBanner;